const VALIDATION_MESSAGES = {
  "primaryVisualDraftOpenDoor_onlyOne": "Please only check one option for primary visual draft, open door.",
  "secondaryVisualDraftOpenDoor_onlyOne": "Please only check one option for secondary visual draft, open door.",
  "waterHeaterVisualDraftOpenDoor_onlyOne": "Please only check one option for water heater visual draft, open door.",
  "otherVisualDraftOpenDoor_onlyOne": "Please only check one option for 'other' visual draft, open door.",

  "primaryVisualDraftClosedDoor_onlyOne": "Please only check one option for primary visual draft, closed door.",
  "secondaryVisualDraftClosedDoor_onlyOne": "Please only check one option for secondary visual draft, closed door.",
  "waterHeaterVisualDraftClosedDoor_onlyOne": "Please only check one option for water heater visual draft, closed door.",
  "otherVisualDraftClosedDoor_onlyOne": "Please only check one option for 'other' visual draft, closed door.",
  
  "primarySpillageOpenDoor_onlyOne": "Please only check one option for primary spillage, open door.",
  "secondarySpillageOpenDoor_onlyOne": "Please only check one option for secondary spillage, open door.",
  "waterHeaterSpillageOpenDoor_onlyOne": "Please only check one option for water heater spillage, open door.",
  "otherSpillageOpenDoor_onlyOne": "Please only check one option for 'other' spillage, open door.",

  "primarySpillageClosedDoor_onlyOne": "Please only check one option for primary spillage, closed door.",
  "secondarySpillageClosedDoor_onlyOne": "Please only check one option for secondary spillage, closed door.",
  "waterHeaterSpillageClosedDoor_onlyOne": "Please only check one option for water heater spillage, closed door.",
  "otherSpillageClosedDoor_onlyOne": "Please only check one option for 'other' spillage, closed door.",

  "gasFireplace_onlyOne": "Please only check one option for gas fireplace",
  "gasLog_onlyOne": "Please only check one option for gas log",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "primaryVisualDraftOpenDoor_pass": () => ({ validate: () => {
        const options = ["primaryVisualDraftOpenDoor_pass", "primaryVisualDraftOpenDoor_fail", "primaryVisualDraftOpenDoor_nf", "primaryVisualDraftOpenDoor_hazard", "primaryVisualDraftOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryVisualDraftOpenDoor_onlyOne'];
      },
    }),
    "secondaryVisualDraftOpenDoor_pass": () => ({ validate: () => {
        const options = ["secondaryVisualDraftOpenDoor_pass", "secondaryVisualDraftOpenDoor_fail", "secondaryVisualDraftOpenDoor_nf", "secondaryVisualDraftOpenDoor_hazard", "secondaryVisualDraftOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryVisualDraftOpenDoor_onlyOne'];
      },
    }),
    "waterHeaterVisualDraftOpenDoor_pass": () => ({ validate: () => {
        const options = ["waterHeaterVisualDraftOpenDoor_pass", "waterHeaterVisualDraftOpenDoor_fail", "waterHeaterVisualDraftOpenDoor_nf", "waterHeaterVisualDraftOpenDoor_hazard", "waterHeaterVisualDraftOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['waterHeaterVisualDraftOpenDoor_onlyOne'];
      },
    }),
    "otherVisualDraftOpenDoor_pass": () => ({ validate: () => {
        const options = ["otherVisualDraftOpenDoor_pass", "otherVisualDraftOpenDoor_fail", "otherVisualDraftOpenDoor_nf", "otherVisualDraftOpenDoor_hazard", "otherVisualDraftOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['otherVisualDraftOpenDoor_onlyOne'];
      },
    }),

    "primaryVisualDraftClosedDoor_pass": () => ({ validate: () => {
        const options = ["primaryVisualDraftClosedDoor_pass", "primaryVisualDraftClosedDoor_fail", "primaryVisualDraftClosedDoor_nf", "primaryVisualDraftClosedDoor_hazard", "primaryVisualDraftClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primaryVisualDraftClosedDoor_onlyOne'];
      },
    }),
    "secondaryVisualDraftClosedDoor_pass": () => ({ validate: () => {
        const options = ["secondaryVisualDraftClosedDoor_pass", "secondaryVisualDraftClosedDoor_fail", "secondaryVisualDraftClosedDoor_nf", "secondaryVisualDraftClosedDoor_hazard", "secondaryVisualDraftClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondaryVisualDraftClosedDoor_onlyOne'];
      },
    }),
    "waterHeaterVisualDraftClosedDoor_pass": () => ({ validate: () => {
        const options = ["waterHeaterVisualDraftClosedDoor_pass", "waterHeaterVisualDraftClosedDoor_fail", "waterHeaterVisualDraftClosedDoor_nf", "waterHeaterVisualDraftClosedDoor_hazard", "waterHeaterVisualDraftClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['waterHeaterVisualDraftClosedDoor_onlyOne'];
      },
    }),
    "otherVisualDraftClosedDoor_pass": () => ({ validate: () => {
        const options = ["otherVisualDraftClosedDoor_pass", "otherVisualDraftClosedDoor_fail", "otherVisualDraftClosedDoor_nf", "otherVisualDraftClosedDoor_hazard", "otherVisualDraftClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['otherVisualDraftClosedDoor_onlyOne'];
      },
    }),

    "primarySpillageOpenDoor_pass": () => ({ validate: () => {
        const options = ["primarySpillageOpenDoor_pass", "primarySpillageOpenDoor_fail", "primarySpillageOpenDoor_nf", "primarySpillageOpenDoor_hazard", "primarySpillageOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primarySpillageOpenDoor_onlyOne'];
      },
    }),
    "secondarySpillageOpenDoor_pass": () => ({ validate: () => {
        const options = ["secondarySpillageOpenDoor_pass", "secondarySpillageOpenDoor_fail", "secondarySpillageOpenDoor_nf", "secondarySpillageOpenDoor_hazard", "secondarySpillageOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondarySpillageOpenDoor_onlyOne'];
      },
    }),
    "waterHeaterSpillageOpenDoor_pass": () => ({ validate: () => {
        const options = ["waterHeaterSpillageOpenDoor_pass", "waterHeaterSpillageOpenDoor_fail", "waterHeaterSpillageOpenDoor_nf", "waterHeaterSpillageOpenDoor_hazard", "waterHeaterSpillageOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['waterHeaterSpillageOpenDoor_onlyOne'];
      },
    }),
    "otherSpillageOpenDoor_pass": () => ({ validate: () => {
        const options = ["otherSpillageOpenDoor_pass", "otherSpillageOpenDoor_fail", "otherSpillageOpenDoor_nf", "otherSpillageOpenDoor_hazard", "otherSpillageOpenDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['otherSpillageOpenDoor_onlyOne'];
      },
    }),

    "primarySpillageClosedDoor_pass": () => ({ validate: () => {
        const options = ["primarySpillageClosedDoor_pass", "primarySpillageClosedDoor_fail", "primarySpillageClosedDoor_nf", "primarySpillageClosedDoor_hazard", "primarySpillageClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['primarySpillageClosedDoor_onlyOne'];
      },
    }),
    "secondarySpillageClosedDoor_pass": () => ({ validate: () => {
        const options = ["secondarySpillageClosedDoor_pass", "secondarySpillageClosedDoor_fail", "secondarySpillageClosedDoor_nf", "secondarySpillageClosedDoor_hazard", "secondarySpillageClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['secondarySpillageClosedDoor_onlyOne'];
      },
    }),
    "waterHeaterSpillageClosedDoor_pass": () => ({ validate: () => {
        const options = ["waterHeaterSpillageClosedDoor_pass", "waterHeaterSpillageClosedDoor_fail", "waterHeaterSpillageClosedDoor_nf", "waterHeaterSpillageClosedDoor_hazard", "waterHeaterSpillageClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['waterHeaterSpillageClosedDoor_onlyOne'];
      },
    }),
    "otherSpillageClosedDoor_pass": () => ({ validate: () => {
        const options = ["otherSpillageClosedDoor_pass", "otherSpillageClosedDoor_fail", "otherSpillageClosedDoor_nf", "otherSpillageClosedDoor_hazard", "otherSpillageClosedDoor_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['otherSpillageClosedDoor_onlyOne'];
      },
    }),

    "gasFireplace_pass": () => ({ validate: () => {
        const options = ["gasFireplace_pass", "gasFireplace_fail", "gasFireplace_hazard", "gasFireplace_nf", "gasFireplace_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasFireplace_onlyOne'];
      },
    }),

    "gasLog_pass": () => ({ validate: () => {
        const options = ["gasLog_pass", "gasLog_fail", "gasLog_hazard", "gasLog_nf", "gasLog_na"];
        const count = options.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasLog_onlyOne'];
      },
    }),
  };
};

export default useValidation;
